import { useTranslation } from 'react-i18next';
import { createUrlWithRedirectQuery } from '@/utils/url';

type UnauthBannerProps = {
  redirectPath: string;
};

export const UnauthBanner = ({ redirectPath }: UnauthBannerProps) => {
  const { t } = useTranslation();

  return (
    <div className="mb-3 rounded-lg border border-rw-main/20 bg-rw-main/10 px-3 py-1 text-sm text-rw-sub shadow-sm sm:px-4 sm:py-2.5">
      <p className="text-base font-semibold text-rw-main">
        {t('RuleWatcherに登録すると、記事の調査・参照を継続しやすくなります。')}
      </p>
      <p className="mt-1.5 text-xs text-rw-sub sm:text-sm">
        {t('続けて記事を便利に活用するには、アカウント登録をおすすめします。')}
      </p>
      <div className="mt-2.5 flex flex-col gap-1.5 sm:flex-row">
        <a
          href={createUrlWithRedirectQuery('/auth/register', redirectPath)}
          className="inline-flex h-8 w-full items-center justify-center rounded-md bg-rw-main px-4 text-sm font-semibold text-white transition-opacity hover:opacity-90 sm:w-fit"
        >
          {t('新規登録')}
        </a>
        <a
          href={createUrlWithRedirectQuery('/auth/login', redirectPath)}
          className="inline-flex h-8 w-full items-center justify-center rounded-md border border-rw-main/30 bg-white px-4 text-sm font-semibold text-rw-main transition-colors hover:bg-slate-50 sm:w-fit"
        >
          {t('ログインする')}
        </a>
      </div>
    </div>
  );
};
